import {FmlxCheckBox} from 'fmlx-common-ui';
import PropTypes from 'prop-types';
import './TaskListCheckbox.scss';

function TaskListCheckbox({onChange, checked}) {
  return (
    <div className="task-list-checkbox" onClick={(e) => e.stopPropagation()} aria-hidden="true">
      <FmlxCheckBox checked={checked} onChange={onChange} />
    </div>
  );
}

TaskListCheckbox.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
};

TaskListCheckbox.defaultProps = {
  checked: false,
  onChange: () => {},
};

export default TaskListCheckbox;
